@if (isLoading() && editedPatientAlertsItemId() === null) {
  <ng-lottie [options]="lottieOptions" currentColor class="mx-auto my-auto w-5 text-primary-blue"></ng-lottie>
} @else {
  <div class="flex items-center justify-end bg-[#FCFDFE] pb-4">
    <button
      class="btn-text gap-[0.625rem] text-[0.875rem]"
      (click)="onAddNewItem()"
      [disabled]="!addPatientAlertEnabled()"
      [libUiTooltip]="!addPatientAlertEnabled() ? addDisabledTooltip : undefined"
      tooltipPosition="bottom"
    >
      <svg-icon [ngClass]="addPatientAlertEnabled() ? 'text-text-blue' : 'text-text-light'" key="px-24-plus"></svg-icon>
      {{ 'health_history_medical_alerts_add_new' | translate }}
    </button>

    <ng-template #addDisabledTooltip>
      <div class="typo-h7-light max-w-[190px] whitespace-pre-wrap p-1">
        {{ 'patient_alerts_add_disabled_tooltip' | translate }}
      </div>
    </ng-template>
  </div>
  @if (newPatientAlertsItem()) {
    <lib-patient-alerts-item
      [patientAlertsItem]="newPatientAlertsItem()!"
      [isEditMode]="editedPatientAlertsItemId() === newPatientAlertsItem()!.id"
      [isNewItem]="true"
      [isLoading]="isLoading()"
      [editPatientAlertEnabled]="editPatientAlertEnabled()"
      [deletePatientAlertEnabled]="deletePatientAlertEnabled()"
      (changeEditMode)="onChangeEditMode($event)"
      (deleteItem)="onDeleteItem($event)"
      (saveItem)="onSaveItem($event)"
      (discardNewItem)="onDiscardNewItem()"
    ></lib-patient-alerts-item>
  }
  @for (alert of patientAlerts(); track alert.id) {
    <lib-patient-alerts-item
      [patientAlertsItem]="alert"
      [isEditMode]="editedPatientAlertsItemId() === alert.id"
      [isNewItem]="false"
      [isLoading]="isLoading()"
      [editPatientAlertEnabled]="editPatientAlertEnabled()"
      [deletePatientAlertEnabled]="deletePatientAlertEnabled()"
      (changeEditMode)="onChangeEditMode($event)"
      (deleteItem)="onDeleteItem($event)"
      (saveItem)="onSaveItem($event)"
      (discardNewItem)="onDiscardNewItem()"
    ></lib-patient-alerts-item>
  } @empty {
    <div class="typo-h5-book flex h-full items-center justify-center py-1 pl-3">
      {{ 'health_history_patient_alerts_tab_empty' | translate }}
    </div>
  }
}
